import moment from 'moment-timezone'

let today = new Date()

const CUSTOM_NAMES = {
  'America/Atikokan': 'Canada/Atikokan',
  'America/Blanc-Sablon': 'Canada/Blanc-Sablon',
  'America/Cambridge_Bay': 'Canada/Cambridge_Bay',
  'America/Coral_Harbour': 'Canada/Coral_Harbour',
  'America/Creston': 'Canada/Creston',
  'America/Dawson': 'Canada/Dawson',
  'America/Dawson_Creek': 'Canada/Dawson_Creek',
  'America/Edmonton': 'Canada/Edmonton',
  'America/Fort_Nelson': 'Canada/Fort_Nelson',
  'America/Glace_Bay': 'Canada/Glace_Bay',
  'America/Goose_Bay': 'Canada/Goose_Bay',
  'America/Halifax': 'Canada/Halifax',
  'America/Inuvik': 'Canada/Inuvik',
  'America/Iqaluit': 'Canada/Iqaluit',
  'America/Moncton': 'Canada/Moncton',
  'America/Montreal': 'Canada/Montreal',
  'America/Nipigon': 'Canada/Nipigon',
  'America/Pangnirtung': 'Canada/Pangnirtung',
  'America/Rainy_River': 'Canada/Rainy_River',
  'America/Rankin_Inlet': 'Canada/Rankin_Inlet',
  'America/Regina': 'Canada/Regina',
  'America/Resolute': 'Canada/Resolute',
  'America/St_Johns': 'Canada/St_Johns',
  'America/Swift_Current': 'Canada/Swift_Current',
  'America/Thunder_Bay': 'Canada/Thunder_Bay',
  'America/Toronto': 'Canada/Toronto',
  'America/Vancouver': 'Canada/Vancouver',
  'America/Whitehorse': 'Canada/Whitehorse',
  'America/Winnipeg': 'Canada/Winnipeg',
  'America/Yellowknife': 'Canada/Yellowknife',
}


export function prettyTimezone(timezone){
  let str = timezone.replace('_', ' ')
  let arr = str.split('/')
  return arr.reverse().join(', ')
}

export const timezonesList = (timeStandard) => {
  return moment.tz.names()
    .map((timezone) => {
      let offset = moment.tz.zone(timezone).parse(today) / 60 * (-1)
      let prettyName = prettyNameFor(timezone)
      let prettyOffset = pad(Math.abs(Math.floor(offset)), 2) + ':' + pad(((offset % 1)*60), 2)
      prettyOffset = offset < 0 ? '-' + prettyOffset : '+' + prettyOffset

      return {
        value: timezone,
        offset: offset,
        city: prettyName.split(', ')[0],
        label: prettyName + ' (' + timeStandard + prettyOffset + ')'
      }
  }).sort((a, b) => ( a.city.localeCompare(b.city) ))
}

function pad(input, length) {
  return (Array(length + 1).join('0') + input).slice(-length);
}

export const groupedTimes = (times, timezone) => {
  return times.reduce((days, time) => {
    const timeDayStart = moment.tz(time, timezone).startOf('day')
    const dayIndex = days.findIndex(x => moment(x.day).isSame(timeDayStart))
    if(dayIndex !== -1) {
      days[dayIndex].times.push(time)
    } else {
      days.push({
        day: timeDayStart,
        times: [time],
      })
    }

    return days
  }, [])
}

const prettyNameFor = (timezone) => {
  const name = CUSTOM_NAMES[timezone] || timezone
  return name.split('/').reverse().join(', ').replace('_', ' ')
}
